import { actions } from './actions';

export const search = {
  state: {
    searchResult: { artworks: [], temples: [], themes: [], albums: [], tags: [], },
  },
  getters: {
    searchResult(state) {
      return state.searchResult;
    },
  },
  mutations: {
    setSearchResult(state, payload) {
      state.searchResult = payload;
    },
  },
  actions,
};